import BillingViewController from './BillingViewController';

export default BillingViewController;
